module.exports = __webpack_public_path__ + "static/media/acne-ON.970fbd7d.png";